import React, { useEffect, useRef, useState } from 'react';
import "./explorejob.scss";
import EastIcon from '@mui/icons-material/East';
import WestIcon from '@mui/icons-material/West';
import Carousel from "react-multi-carousel";
import "react-multi-carousel/lib/styles.css";
import { Link } from 'react-router-dom';
import { axiosApi } from '../../../../_helper/api_helper';
import HireJobModel from '../../../hiretalentjob/HireJobModel';
import RecuiterModal from '../../../FindRecuriter/RecuiterModal';



const ExploreTopJobAbdProject = () => {
    const carouselRef = useRef(null);


    const [jobData, setJobData] = useState([]);
    const [projectData, setProjectData] = useState([])
    
    const [IndustriesData, setIndustriesData] = useState([]);

    const [activeButton, setActiveButton] = useState(null);
    const [activeJobButton, setActiveJobButton] = useState('Job')
    const [modalShow, setModalShow] = React.useState(false);
    const [selectedRecruiterId, setSelectedRecruiterId] = useState(null);
    const [mutliJobId, setMutliJobId] = useState('')
    const [isJobModal, setIsJobModal] = useState(true);

    useEffect(() => {
        IndustriesGet();

    }, []);
    const IndustriesGet = async () => {
        const response = await axiosApi.get("/industries");
        setIndustriesData(response?.data)
    }
    useEffect(() => {
        jobGetApi();
        projectapi();
    }, [])



    const jobGetApi = async () => {
        const response = await axiosApi.get(`/jobs/all`);
        setJobData(response?.data)

    }
    const projectapi = async () => {
        const response = await axiosApi.get('/multijobs/all');
        setProjectData(response?.data)
    }
    const scrollLeft = () => {
        if (carouselRef.current) {
            carouselRef.current.previous();
        }
        setActiveButton('left');
    }

    const scrollRight = () => {
        if (carouselRef.current) {
            carouselRef.current.next();
        }
        setActiveButton('right');
    }
    const getCarouselData = () => {
        return activeJobButton === 'Job' ? jobData : projectData;
    }
    const handleButtonClick = (type) => {
        setActiveJobButton(type);
    }
    const handleViewDetailClick = (item) => {
        if (item.job_id) {
            setIsJobModal(true); // Set to open Job modal
            setSelectedRecruiterId(item.job_id);
            setMutliJobId(item.recruiter_id);
        } else if (item.project_id) {
            setIsJobModal(false); // Set to open Project modal
            setSelectedRecruiterId(item.project_id);
            setMutliJobId(item.recruiter_id);
        }
        setModalShow(true);
    };
    const calculateTimeElapsed = (createdAt) => {
        const currentDate = new Date();
        const postedDate = new Date(createdAt);
        const timeDifference = currentDate - postedDate;

        const seconds = Math.floor(timeDifference / 1000);
        const minutes = Math.floor(seconds / 60);
        const hours = Math.floor(minutes / 60);
        const days = Math.floor(hours / 24);
        const weeks = Math.floor(days / 7);
        const months = Math.floor(days / 30);
        const years = Math.floor(days / 365);

        if (years > 0) {
            return `${years} ${years === 1 ? 'year' : 'years'} ago`;
        } else if (months > 0) {
            return `${months} ${months === 1 ? 'month' : 'months'} ago`;
        } else if (weeks > 0) {
            return `${weeks} ${weeks === 1 ? 'week' : 'weeks'} ago`;
        } else if (days > 0) {
            return `${days} ${days === 1 ? 'day' : 'days'} ago`;
        } else if (hours > 0) {
            return `${hours} ${hours === 1 ? 'hour' : 'hours'} ago`;
        } else if (minutes > 0) {
            return `${minutes} ${minutes === 1 ? 'minute' : 'minutes'} ago`;
        } else {
            return `${seconds} ${seconds === 1 ? 'second' : 'seconds'} ago`;
        }
    };
    return (
        <>
            <div className="explore-top-home-container">
                <div className="explore-top-home">

                    <div className="home-explore-top">
                        <div className="explore-job-inner">
                            <div className="explore-top-job-heading">
                                <h3>Explore Top Jobs and Projects</h3>
                                <p>Hire Freelancers-Find the Project Fit for Your Project Needs!</p>
                            </div>
                            <div className="explore-top-job-heading explore-top-job-view">
                                <Link to={activeJobButton == 'Job' ? "/hire-talent" : "/all-project-posted"}><button> View All <EastIcon className='explore-easr-icon' /></button></Link>
                            </div>
                        </div>

                        <div className="home-explore-job-project-inner">
                            <div className="home-explore-job-project-first">
                                <button onClick={() => handleButtonClick('Job')}
                                    style={{ backgroundColor: activeJobButton === 'Job' ? 'black' : 'white', color: activeJobButton === 'Job' ? 'white' : 'black' }}
                                >Job</button>
                                <button onClick={() => handleButtonClick('Project')}
                                    style={{ backgroundColor: activeJobButton === 'Project' ? 'black' : 'white', color: activeJobButton === 'Project' ? 'white' : 'black' }}
                                >Project</button>
                                
                            </div>
                            <div className="blog-inner-second">

                                <div className="inner-button-carousel" >
                                    <button className={`carousel-button left ${activeButton === 'left' ? 'active' : ''}`} onClick={scrollLeft}><WestIcon className='icon-left' /></button>
                                    <button className={`carousel-button right ${activeButton === 'right' ? 'active' : ''}`} onClick={scrollRight}><EastIcon className='icon-left' /></button>
                                </div>


                            </div>
                        </div>
                    </div>


                    <div className="slick-carousel-blogs" >
                        <div className="slick-container">

                            <div>
                                <Carousel
                                    ref={carouselRef}
                                    additionalTransfrom={0}
                                    arrows={false}
                                    autoPlaySpeed={3000}
                                    centerMode={false}
                                    className=""
                                    containerClass="carousel-container"
                                    customButtonGroup={<button></button>}
                                    dotListClass=""
                                    draggable
                                    focusOnSelect={false}
                                    infinite
                                    itemClass=""
                                    keyBoardControl
                                    minimumTouchDrag={80}
                                    renderButtonGroupOutside={false}
                                    renderDotsOutside={false}
                                    responsive={{
                                        desktop: {
                                            breakpoint: {
                                                max: 3000,
                                                min: 1024
                                            },
                                            items: 3
                                        },
                                        mobile: {
                                            breakpoint: {
                                                max: 464,
                                                min: 0
                                            },
                                            items: 1
                                        },
                                        tablet: {
                                            breakpoint: {
                                                max: 1024,
                                                min: 464
                                            },
                                            items: 2
                                        }
                                    }}
                                    showDots={false}
                                    sliderClass=""
                                    slidesToSlide={1}
                                    swipeable
                                >
                                    {getCarouselData().map((item, index) => (
                                        <div
                                            onClick={() => handleViewDetailClick(item)}
                                            className='explore-home-job-container' key={index}>
                                            <div className="explore-home-job-container-inner">
                                                <div className='explore-job-title'>{item?.job_title || item?.project_title?.replace(/^"|"$/g, '')}</div>
                                                <div className='explore-job-hosted'>Hosted by {item?.recruiter_name || item?.recruiter_organisation_name}</div>
                                                <div className='explore-job-para'>{(item?.job_description || item?.project_description)?.slice(0, 80)}...</div>
                                                <div className="explore-job-place">
                                                    <span><img src="/svg/location.svg" alt="" /> {item?.job_city_new || item?.project_city_new}</span>
                                                    {item?.experience_level && <span><img src="/svg/bag.svg" alt="" /> {item?.experience_level}</span>}
                                                    <span><img src="/svg/rupee.svg" alt="" />
                                                        {item?.job_salary
                                                            || (item.min_perhour && item.max_perhour ? `₹${item.min_perhour} - ₹${item.max_perhour}`
                                                                : item.min_fixedprice && item.max_fixedprice ? `₹${item.min_fixedprice} - ₹${item.max_fixedprice}`
                                                                    : 'N/A')}
                                                    </span>

                                                </div>
                                                <div style={{ cursor: "pointer" }} className='explore-job-button m'>
                                                    <Link to={`/project-details/${item?.project_id}/${item?.recruiter_id}`}>
                                                    View Detail
                                                    </Link>
                                                    
                                                    <div className="date-posted">{calculateTimeElapsed(item?.created_at)}</div>
                                                </div>
                                            </div>
                                        </div>
                                    ))}
                                </Carousel>
                            </div>

                        </div>


                    </div>
                </div>
            </div>

            {isJobModal ? (
                <HireJobModel
                    show={modalShow}
                    onHide={() => setModalShow(false)}
                    filterData={selectedRecruiterId}
                    mutliJobId={mutliJobId}
                    selectedRecruiterId={selectedRecruiterId}
                />
            ) : (
                <RecuiterModal
                    show={modalShow}
                    onHide={() => setModalShow(false)}
                    filterData={selectedRecruiterId}
                    mutliJobId={mutliJobId}
                />
            )}
        </>
    )
}

export default ExploreTopJobAbdProject